import React__default from 'react';
import classnames from 'classnames';
import { QuantityItem } from '../QuantityItem/QuantityItem.js';

const QuantityContainerButton = ({ item , isSelected , onClick  })=>{
    return /*#__PURE__*/ React__default.createElement("button", {
        className: classnames('quantity-container__item', {
            _is_selected: isSelected
        }),
        onClick: onClick,
        "data-t": item.value
    }, /*#__PURE__*/ React__default.createElement(QuantityItem, {
        className: "quantity-container",
        label: item.label,
        subtext: item.subtext,
        aside: item.aside
    }));
};

export { QuantityContainerButton };
//# sourceMappingURL=QuantityContainerButton.js.map
